export default __webpack_public_path__ + "static/media/baseline-signal_wifi_3_bar-24px.6c54583d.svg";